// Define Image Carousel WebComponent
if (!customElements.get('image-carousel-component')) {
  class ImageCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this.currentIndex = 0;
      this.autoSlideTimer = null;
      this.slidesData = [];
      this.slideTemplates = [];
      this.isVideoPlaying = false;
      this.autoSlideInterval = 0;
      this.eventListenersInitialized = false;
    }

    connectedCallback() {
      const fullScreenMode = this.getAttribute('data-full-screen') === 'true';
      const autoSlideInterval = parseInt(this.getAttribute('data-auto-slide-interval')) || 5000;
      const navButtonShape = this.getAttribute('data-nav-button-shape') || 'circle';
      const navButtonColor = this.getAttribute('data-nav-button-color') || '#000000';
      const navButtonBackground = this.getAttribute('data-nav-button-background') || '#ffffff';
      const navButtonHoverColor = this.getAttribute('data-nav-button-hover-color') || '#000000';
      const navButtonHoverBackground = this.getAttribute('data-nav-button-hover-background') || '#f0f0f0';
      const productInfoWidth = this.getAttribute('data-product-info-width') || '50';
      const productInfoWidthMobile = this.getAttribute('data-product-info-width-mobile') || '80';
      const productInfoPaddingTop = this.getAttribute('data-product-info-padding-top') || '60';
      const productInfoPaddingBottom = this.getAttribute('data-product-info-padding-bottom') || '60';
      const productInfoPosition = this.getAttribute('data-product-info-position') || 'bottom-left';
      const cssUrl = this.getAttribute('data-css-url') || '';
      const pcHeight = this.getAttribute('data-pc-height') || '600';
      const mobileHeight = this.getAttribute('data-mobile-height') || '400';
      
      this.autoSlideInterval = autoSlideInterval;
      this.pcHeight = pcHeight;
      this.mobileHeight = mobileHeight;
      this._resizeHandler = null;
      this._isMobile = window.innerWidth <= 768;

      const slidesDataJson = this.getAttribute('data-slides');
      if (slidesDataJson) {
        this.slidesData = JSON.parse(slidesDataJson);
      }

      const templates = this.querySelectorAll('template[data-slide-index]');
      templates.forEach(template => {
        const index = parseInt(template.dataset.slideIndex);
        const content = template.content;
        const tempDiv = document.createElement('div');
        tempDiv.appendChild(content.cloneNode(true));
        this.slideTemplates[index] = tempDiv.innerHTML;
      });

      this.render(fullScreenMode, autoSlideInterval, navButtonShape, navButtonColor, navButtonBackground, navButtonHoverColor, navButtonHoverBackground, productInfoWidth, productInfoWidthMobile, productInfoPaddingTop, productInfoPaddingBottom, productInfoPosition, cssUrl);

      this._resizeHandler = () => this.handleResize();
      window.addEventListener('resize', this._resizeHandler);
    }

    render(fullScreenMode, autoSlideInterval, navButtonShape, navButtonColor, navButtonBackground, navButtonHoverColor, navButtonHoverBackground, productInfoWidth, productInfoWidthMobile, productInfoPaddingTop, productInfoPaddingBottom, productInfoPosition, cssUrl) {
      const slides = this.slidesData;
      const slideCount = slides.length;
      const firstSlide = slideCount > 0 ? slides[0] : {
        image: '',
        title: 'Product Title',
        description: 'Product description',
        buttonText: 'Shop now',
        buttonLink: '#'
      };

      const isMobile = this._isMobile;
      const actualFullScreenMode = isMobile ? true : fullScreenMode;
      const actualProductInfoWidth = isMobile ? productInfoWidthMobile : productInfoWidth;
      const hasMultipleSlides = slideCount > 1;
      const navButtonsHtml = hasMultipleSlides ? '<button class="prev-btn"></button><button class="next-btn"></button>' : '';
      const prevSlide = hasMultipleSlides ? this.renderSlide(slides[slideCount - 1], slideCount - 1, false, isMobile, actualFullScreenMode, actualProductInfoWidth) : '';
      const nextSlide = hasMultipleSlides ? this.renderSlide(slides[0], 0, false, isMobile, actualFullScreenMode, actualProductInfoWidth) : '';
      const currentSlidesHtml = slides.map((slide, index) => this.renderSlide(slide, index, index === 0, isMobile, actualFullScreenMode, actualProductInfoWidth)).join('');
      const thumbnailsHtml = hasMultipleSlides ? `<div class="thumbnail-container">${slides.map((slide, index) => `<span class="thumbnail ${index === 0 ? 'active' : ''}" data-index="${index}"></span>`).join('')}</div>` : '';
      const buttonRadius = navButtonShape === 'square' ? '4px' : '50%';
      const titleFontSize = firstSlide.titleFontSize ? firstSlide.titleFontSize + 'px' : '32px';
      const titleColor = firstSlide.titleColor || '#000000';
      const titleBold = firstSlide.titleBold ? 'bold' : 'normal';
      const descFontSize = firstSlide.descriptionFontSize ? firstSlide.descriptionFontSize + 'px' : '16px';
      const descColor = firstSlide.descriptionColor || '#666666';
      const descBold = firstSlide.descriptionBold ? 'bold' : 'normal';
      const btnFontSize = firstSlide.buttonFontSize ? firstSlide.buttonFontSize + 'px' : '16px';
      const btnColor = firstSlide.buttonColor || '#ffffff';
      const btnBg = firstSlide.buttonBackground || '#e63946';
      const btnBold = firstSlide.buttonBold ? 'bold' : 'normal';
      const btnSize = firstSlide.buttonSize || 'medium';
      const btnIcon = firstSlide.buttonIcon || '';
      const btnIconPosition = firstSlide.buttonIconPosition || 'left';
      let btnPadding = '12px 24px';
      let btnIconSize = '20px';
      if (btnSize === 'small') { btnPadding = '8px 16px'; btnIconSize = '16px'; }
      else if (btnSize === 'large') { btnPadding = '16px 32px'; btnIconSize = '24px'; }
      const btnIconHtml = btnIcon ? `<img src="${btnIcon}" alt="" width="${btnIconSize}" height="${btnIconSize}" style="width: ${btnIconSize} !important; height: ${btnIconSize} !important;${btnIconPosition === 'right' ? ' margin-left: 8px; margin-right: 0; order: 2;' : ' margin-right: 8px; margin-left: 0; order: 1;'} flex-shrink: 0;" >` : '';
      const buttonHtml = firstSlide.buttonText ? `<a href="${firstSlide.buttonLink}" class="shop-now-btn" style="padding: ${btnPadding} !important; display: flex !important; align-items: center !important; justify-content: ${btnIconPosition === 'right' ? 'flex-end' : 'flex-start'};">${btnIconHtml}<span style="order: ${btnIconPosition === 'right' ? '1' : '2'}; flex-shrink: 0;">${firstSlide.buttonText}</span></a>` : '';

      const styleElement = document.createElement('style');
      styleElement.textContent = `@import url('${cssUrl}');`;
      this.shadowRoot.appendChild(styleElement);

      const container = document.createElement('div');
      container.className = 'product-showcase';
      container.innerHTML = `
        <div class="product-container" style="--nav-button-shape-radius: ${buttonRadius}; --nav-button-color: ${navButtonColor}; --nav-button-background: ${navButtonBackground}; --nav-button-hover-color: ${navButtonHoverColor}; --nav-button-hover-background: ${navButtonHoverBackground};">
          ${navButtonsHtml}
          <div class="product-image-container ${actualFullScreenMode ? 'full-screen' : 'with-preview'}">
            <div class="product-image-wrapper">${prevSlide}${currentSlidesHtml}${nextSlide}</div>
          </div>
          <div class="product-info position-${productInfoPosition}" style="--title-font-size: ${titleFontSize}; --title-color: ${titleColor}; --title-font-weight: ${titleBold}; --description-font-size: ${descFontSize}; --description-color: ${descColor}; --description-font-weight: ${descBold}; --button-font-size: ${btnFontSize}; --button-color: ${btnColor}; --button-background: ${btnBg}; --button-font-weight: ${btnBold}; --product-info-width: ${actualProductInfoWidth}%; --product-info-padding-top: ${productInfoPaddingTop}px; --product-info-padding-bottom: ${productInfoPaddingBottom}px;">
            <h1 class="product-title">${firstSlide.title}</h1>
            <p class="product-subtitle">${firstSlide.description}</p>
            ${buttonHtml}
          </div>
        </div>
        ${thumbnailsHtml}
      `;
      this.shadowRoot.appendChild(container);

      this.initEventListeners(autoSlideInterval);
      this.createPreviewImages(fullScreenMode);
      this.handleResize();

      if (slideCount > 0 && this.slidesData[0].type === 'video') {
        const videoAutoplay = isMobile ? this.slidesData[0].mobileVideoAutoplay : this.slidesData[0].pcVideoAutoplay;
        if (videoAutoplay) {
          this.playVideo(0);
        } else if (autoSlideInterval > 0) {
          this.startAutoSlide(autoSlideInterval);
        }
      } else if (autoSlideInterval > 0) {
        this.startAutoSlide(autoSlideInterval);
      }

      const imageWrapper = this.shadowRoot.querySelector('.product-image-wrapper');
      if (imageWrapper) {
        if (hasMultipleSlides) {
          imageWrapper.style.transform = actualFullScreenMode ? 'translateX(-100%)' : 'translateX(calc(-100% - 20px))';
        } else {
          imageWrapper.style.transform = 'translateX(0)';
        }
      }
    }

    renderSlide(slide, index, isActive, isMobile, fullScreenMode, productInfoWidth) {
      const templateHtml = this.slideTemplates[index] || '';
      const buttonText = slide.buttonText || '';
      const buttonLink = slide.buttonLink || '';
      const hasButton = buttonText.trim() !== '';
      const hasLink = buttonLink.trim() !== '';
      
      if (slide.type === 'video') {
        const videoContent = `
          <div class="slide-container ${isActive ? 'active' : ''}" data-index="${index}" data-type="video">
            <div class="video-container">
              ${this.selectImageByDevice(templateHtml, isMobile, 'video-cover') || this.renderVideoCoverFallback(slide, isMobile)}
              <button class="play-button" data-index="${index}" aria-label="Play video"></button>
              <div class="video-player" data-index="${index}">
                ${this.renderVideoPlayer(slide, isMobile)}
              </div>
            </div>
          </div>
        `;
        if (!hasButton && hasLink) {
          return `<a href="${buttonLink}" class="slide-link">${videoContent}</a>`;
        }
        return videoContent;
      } else {
        const imageContent = this.selectImageByDevice(templateHtml, isMobile, 'product-image', isActive, index) || this.renderImageFallback(slide, index, isActive, isMobile, fullScreenMode);
        if (!hasButton && hasLink) {
          return `<a href="${buttonLink}" class="slide-link">${imageContent}</a>`;
        }
        return imageContent;
      }
    }

    renderVideoCoverFallback(slide, isMobile) {
      const coverImage = isMobile ? (slide.mobileVideoCover || slide.pcVideoCover || '') : (slide.pcVideoCover || slide.mobileVideoCover || '');
      if (!coverImage) return '<img src="data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="1600" height="900"%3E%3Crect width="1600" height="900" fill="%23cccccc"/%3E%3C/svg%3E" alt="" class="video-cover" loading="lazy">';
      return `<img src="${coverImage}" alt="" class="video-cover" loading="lazy">`;
    }

    renderImageFallback(slide, index, isActive, isMobile, fullScreenMode) {
      const imageUrl = isMobile ? (slide.mobileImage || slide.pcImage || '') : (slide.pcImage || slide.mobileImage || '');
      const imageSrcset = isMobile ? (slide.mobileImageSrcset || slide.pcImageSrcset || '') : (slide.pcImageSrcset || slide.mobileImageSrcset || '');
      const imageSizes = fullScreenMode ? '100vw' : 'calc(100vw - 180px)';
      return `<img src="${imageUrl}" srcset="${imageSrcset}" sizes="${imageSizes}" alt="${slide.title || ''}" class="product-image ${isActive ? 'active' : ''}" data-index="${index}" loading="lazy">`;
    }

    selectImageByDevice(html, isMobile, baseClass, isActive = false, index = 0) {
      if (!html) return '';
      
      const targetClass = isMobile ? '-mobile' : '-pc';
      const otherClass = isMobile ? '-pc' : '-mobile';
      
      let result = html;
      
      const targetRegex = new RegExp(`<img([^>]*?)class="([^"]*?)${targetClass}([^"]*?)"([^>]*?)>`, 'i');
      const otherRegex = new RegExp(`<img([^>]*?)class="([^"]*?)${otherClass}([^"]*?)"([^>]*?)>`, 'i');
      
      const targetMatch = result.match(targetRegex);
      const otherMatch = result.match(otherRegex);
      
      if (targetMatch) {
        result = targetMatch[0];
      } else if (otherMatch) {
        result = otherMatch[0];
      } else {
        const imgMatch = result.match(/<img[^>]*>/i);
        if (imgMatch) {
          result = imgMatch[0];
        } else {
          return '';
        }
      }
      
      if (baseClass === 'product-image') {
        result = result.replace(/class="([^"]*?)"/i, `class="product-image ${isActive ? 'active' : ''}"`);
        if (!result.includes('data-index=')) {
          result = result.replace('<img', `<img data-index="${index}"`);
        } else {
          result = result.replace(/data-index="\d*"/, `data-index="${index}"`);
        }
      } else {
        result = result.replace(/class="([^"]*?)"/i, 'class="video-cover"');
      }
      
      return result;
    }

    renderVideoPlayer(slide, isMobile) {
      const videoType = isMobile ? slide.mobileVideoType : slide.pcVideoType;
      const videoUrl = isMobile ? slide.mobileVideoUrl : slide.pcVideoUrl;
      const videoAutoplay = isMobile ? slide.mobileVideoAutoplay : slide.pcVideoAutoplay;
      if (videoType === 'youtube' && videoUrl) {
        const videoId = this.extractYouTubeId(videoUrl);
        if (videoId) {
          const autoplayParam = videoAutoplay ? '?autoplay=1' : '';
          return `<iframe data-src="https://www.youtube.com/embed/${videoId}${autoplayParam}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
        }
      } else if (videoType === 'upload' && videoUrl) {
        const autoplayAttr = videoAutoplay ? 'autoplay' : '';
        return `<video muted playsinline ${autoplayAttr}><source src="${videoUrl}" type="video/mp4">Your browser does not support the video tag.</video>`;
      }
      return '';
    }

    extractYouTubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return (match && match[2].length === 11) ? match[2] : null;
    }

    initEventListeners(autoSlideInterval) {
      if (this.eventListenersInitialized) {
        return;
      }
      this.eventListenersInitialized = true;

      const prevBtn = this.shadowRoot.querySelector('.prev-btn');
      if (prevBtn) {
        prevBtn.addEventListener('click', () => this.goToPrevious());
      }

      const nextBtn = this.shadowRoot.querySelector('.next-btn');
      if (nextBtn) {
        nextBtn.addEventListener('click', () => this.goToNext());
      }

      const thumbnails = this.shadowRoot.querySelectorAll('.thumbnail');
      thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
          this.isVideoPlaying = false;
          if (this.autoSlideInterval > 0) {
            this.startAutoSlide(this.autoSlideInterval);
          }
          this.updateSlide(index);
        });
      });

      const productContainer = this.shadowRoot.querySelector('.product-container');
      if (productContainer) {
        productContainer.addEventListener('mouseenter', () => {
          if (this.autoSlideTimer) {
            clearInterval(this.autoSlideTimer);
          }
        });

        productContainer.addEventListener('mouseleave', () => {
          if (autoSlideInterval > 0) {
            this.startAutoSlide(autoSlideInterval);
          }
        });
      }

      const playButtons = this.shadowRoot.querySelectorAll('.play-button');
      playButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          e.stopPropagation();
          const index = parseInt(button.dataset.index);
          this.playVideo(index);
        });
      });
    }

    playVideo(index) {
      // 立即停止自动滑动
      this.stopAutoSlide();
      this.isVideoPlaying = true;
      
      const slideContainers = this.shadowRoot.querySelectorAll('.slide-container');
      slideContainers.forEach((container) => {
        const containerIndex = parseInt(container.dataset.index);
        if (containerIndex === index) {
          const videoPlayer = container.querySelector('.video-player');
          const playButton = container.querySelector('.play-button');
          const videoCover = container.querySelector('.video-cover');
          const iframe = videoPlayer ? videoPlayer.querySelector('iframe') : null;
          const video = videoPlayer ? videoPlayer.querySelector('video') : null;
          
          console.log('Playing video:', index, 'iframe:', !!iframe, 'video:', !!video);
          
          if (videoCover) {
            videoCover.classList.add('hidden');
          }
          if (playButton) {
            playButton.classList.add('hidden');
          }
          if (videoPlayer) {
            videoPlayer.classList.add('active');
          }
          
          if (iframe) {
            // 提取YouTube视频ID
            const videoUrl = iframe.dataset.src || iframe.src;
            const videoId = this.extractYouTubeId(videoUrl);
            if (videoId) {
              // 构建新的src URL，确保包含autoplay=1和随机参数
              const randomParam = Math.random().toString(36).substring(2, 10);
              const src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0&t=${randomParam}`;
              
              console.log('Loading YouTube iframe:', src);
              
              const newIframe = document.createElement('iframe');
              newIframe.src = src;
              newIframe.frameBorder = '0';
              newIframe.allow = 'autoplay; encrypted-media; accelerometer; gyroscope; picture-in-picture';
              newIframe.allowFullscreen = true;
              newIframe.style.width = '100%';
              newIframe.style.height = '100%';
              
              iframe.parentNode.replaceChild(newIframe, iframe);
            }
          }
          
          if (video) {
            console.log('Playing uploaded video');
            video.play().then(() => {
              // 添加视频结束事件监听器
              video.addEventListener('ended', () => {
                this.isVideoPlaying = false;
                if (this.autoSlideInterval > 0) {
                  this.startAutoSlide(this.autoSlideInterval);
                }
              });
            }).catch(err => {
              console.error('Video play error:', err);
              // 如果视频播放失败，恢复自动滑动
              this.isVideoPlaying = false;
              if (this.autoSlideInterval > 0) {
                this.startAutoSlide(this.autoSlideInterval);
              }
            });
          }
        }
      });
    }

    createPreviewImages(fullScreenMode) {
    }

    resetVideo(container) {
      const videoPlayer = container.querySelector('.video-player');
      const playButton = container.querySelector('.play-button');
      const videoCover = container.querySelector('.video-cover');
      const iframe = videoPlayer ? videoPlayer.querySelector('iframe') : null;
      const video = videoPlayer ? videoPlayer.querySelector('video') : null;
      
      if (videoPlayer) {
        videoPlayer.classList.remove('active');
      }
      if (playButton) {
        playButton.classList.remove('hidden');
      }
      if (videoCover) {
        videoCover.classList.remove('hidden');
      }
      
      if (iframe) {
        const newIframe = iframe.cloneNode(false);
        iframe.parentNode.replaceChild(newIframe, iframe);
        this.isVideoPlaying = false;
      }
      
      if (video) {
        video.pause();
        video.currentTime = 0;
        this.isVideoPlaying = false;
      }
    }

    updateSlide(index, isTransition = true) {
      if (this.slidesData.length <= 1) return;

      const totalSlides = this.slidesData.length;
      
      let actualIndex = index;
      if (index === -1) {
        actualIndex = totalSlides - 1;
      } else if (index === totalSlides) {
        actualIndex = 0;
      }
      
      const displayIndex = actualIndex + 1;
      
      const imageWrapper = this.shadowRoot.querySelector('.product-image-wrapper');
      const imageContainer = this.shadowRoot.querySelector('.product-image-container');
      const isMobile = window.innerWidth <= 768;
      const fullScreenMode = this.getAttribute('data-full-screen') === 'true';
      const actualFullScreenMode = isMobile ? true : fullScreenMode;
      const isFullScreen = imageContainer && imageContainer.classList.contains('full-screen');
      
      if (imageWrapper) {
        imageWrapper.style.transition = isTransition ? 'transform 0.5s ease' : 'none';
        if (isFullScreen) {
          imageWrapper.style.transform = `translateX(-${displayIndex * 100}%)`;
        } else {
          imageWrapper.style.transform = `translateX(calc(-${displayIndex * 100}% - ${displayIndex * 20}px))`;
        }
      }

      const images = this.shadowRoot.querySelectorAll('.product-image');
      images.forEach((img, i) => {
        const dataIndex = parseInt(img.dataset.index);
        if (dataIndex === actualIndex) {
          img.classList.add('active');
        } else {
          img.classList.remove('active');
        }
      });

      const slideContainers = this.shadowRoot.querySelectorAll('.slide-container');
      slideContainers.forEach((container) => {
        const dataIndex = parseInt(container.dataset.index);
        if (dataIndex === actualIndex) {
          container.classList.add('active');
          const slide = this.slidesData[actualIndex];
          const isMobile = window.innerWidth <= 768;
          const videoAutoplay = isMobile ? slide.mobileVideoAutoplay : slide.pcVideoAutoplay;
          if (slide.type === 'video' && videoAutoplay) {
            this.playVideo(actualIndex);
          }
        } else {
          container.classList.remove('active');
          this.resetVideo(container);
        }
      });

      const slide = this.slidesData[actualIndex];
      const productInfo = this.shadowRoot.querySelector('.product-info');
      if (productInfo) {
        productInfo.style.setProperty('--title-font-size', slide.titleFontSize ? slide.titleFontSize + 'px' : '32px');
        productInfo.style.setProperty('--title-color', slide.titleColor || '#000000');
        productInfo.style.setProperty('--title-font-weight', slide.titleBold ? 'bold' : 'normal');
        productInfo.style.setProperty('--description-font-size', slide.descriptionFontSize ? slide.descriptionFontSize + 'px' : '16px');
        productInfo.style.setProperty('--description-color', slide.descriptionColor || '#666666');
        productInfo.style.setProperty('--description-font-weight', slide.descriptionBold ? 'bold' : 'normal');
        productInfo.style.setProperty('--button-font-size', slide.buttonFontSize ? slide.buttonFontSize + 'px' : '16px');
        productInfo.style.setProperty('--button-color', slide.buttonColor || '#ffffff');
        productInfo.style.setProperty('--button-background', slide.buttonBackground || '#e63946');
        productInfo.style.setProperty('--button-font-weight', slide.buttonBold ? 'bold' : 'normal');
        const btnSize = slide.buttonSize || 'medium';
        const btnIcon = slide.buttonIcon || '';
        const btnIconPosition = slide.buttonIconPosition || 'left';
        let btnPadding = '12px 24px';
        let btnIconSize = '20px';
        if (btnSize === 'small') { btnPadding = '8px 16px'; btnIconSize = '16px'; }
        else if (btnSize === 'large') { btnPadding = '16px 32px'; btnIconSize = '24px'; }
        const btnIconHtml = btnIcon ? `<img src="${btnIcon}" alt="" width="${btnIconSize}" height="${btnIconSize}" style="width: ${btnIconSize} !important; height: ${btnIconSize} !important;${btnIconPosition === 'right' ? ' margin-left: 8px; margin-right: 0; order: 2;' : ' margin-right: 8px; margin-left: 0; order: 1;'} flex-shrink: 0;" >` : '';
        const buttonHtml = slide.buttonText ? `<a href="${slide.buttonLink}" class="shop-now-btn" style="padding: ${btnPadding} !important; display: flex !important; align-items: center !important; justify-content: ${btnIconPosition === 'right' ? 'flex-end' : 'flex-start'};">${btnIconHtml}<span style="order: ${btnIconPosition === 'right' ? '1' : '2'}; flex-shrink: 0;">${slide.buttonText}</span></a>` : '';
        productInfo.innerHTML = `
          <h1 class="product-title">${slide.title}</h1>
          <p class="product-subtitle">${slide.description}</p>
          ${buttonHtml}
        `;
      }

      const thumbnails = this.shadowRoot.querySelectorAll('.thumbnail');
      thumbnails.forEach((thumb, i) => {
        if (i === actualIndex) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      });

      this.currentIndex = actualIndex;
      
      this.createPreviewImages(actualFullScreenMode);

      if (isTransition) {
        setTimeout(() => {
          if (index === -1) {
            this.updateSlide(totalSlides - 1, false);
          } else if (index === totalSlides) {
            this.updateSlide(0, false);
          }
        }, 500);
      }
    }

    goToPrevious() {
      this.isVideoPlaying = false;
      if (this.autoSlideInterval > 0) {
        this.startAutoSlide(this.autoSlideInterval);
      }
      let newIndex = this.currentIndex - 1;
      this.updateSlide(newIndex);
    }

    goToNext() {
      this.isVideoPlaying = false;
      if (this.autoSlideInterval > 0) {
        this.startAutoSlide(this.autoSlideInterval);
      }
      let newIndex = this.currentIndex + 1;
      this.updateSlide(newIndex);
    }

    startAutoSlide(interval) {
      if (this.autoSlideTimer) {
        clearInterval(this.autoSlideTimer);
      }
      this.autoSlideTimer = setInterval(() => {
        if (!this.isVideoPlaying) {
          this.goToNext();
        }
      }, interval);
    }

    stopAutoSlide() {
      if (this.autoSlideTimer) {
        clearInterval(this.autoSlideTimer);
        this.autoSlideTimer = null;
      }
    }

    handleResize() {
      const isMobile = window.innerWidth <= 768;
      this._isMobile = isMobile;
      const fullScreenMode = this.getAttribute('data-full-screen') === 'true';
      const actualFullScreenMode = isMobile ? true : fullScreenMode;
      const productInfoWidthMobile = this.getAttribute('data-product-info-width-mobile') || '80';
      const actualProductInfoWidth = isMobile ? productInfoWidthMobile : (this.getAttribute('data-product-info-width') || '50');

      const imageContainer = this.shadowRoot.querySelector('.product-image-container');
      if (imageContainer) {
        if (actualFullScreenMode) {
          imageContainer.classList.add('full-screen');
          imageContainer.classList.remove('with-preview');
        } else {
          imageContainer.classList.remove('full-screen');
          imageContainer.classList.add('with-preview');
        }
      }

      const imageWrapper = this.shadowRoot.querySelector('.product-image-wrapper');
      const slides = this.slidesData;
      if (imageWrapper && slides.length > 1) {
        const displayIndex = this.currentIndex + 1;
        imageWrapper.style.transform = actualFullScreenMode
          ? `translateX(-${displayIndex * 100}%)`
          : `translateX(calc(-${displayIndex * 100}% - ${displayIndex * 20}px))`;
      }

      const productInfo = this.shadowRoot.querySelector('.product-info');
      if (productInfo) {
        productInfo.style.setProperty('--product-info-width', `${actualProductInfoWidth}%`);
      }
    }

    disconnectedCallback() {
      if (this.autoSlideTimer) {
        clearInterval(this.autoSlideTimer);
      }
      if (this._resizeHandler) {
        window.removeEventListener('resize', this._resizeHandler);
      }
    }
  }

  customElements.define('image-carousel-component', ImageCarouselComponent);
}